module.exports = __webpack_public_path__ + "img/Instagram post - 5.4d371512.png";